import React from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
} from '@mui/material';
import { Button } from '@finpay-development/shared-components';

export interface UpdateInsuranceAfterVobDialogProps {
  open: boolean;
  isSaving?: boolean;
  onYes: () => void;
  onNo: () => void;
}

export const UpdateInsuranceAfterVobDialog: React.FC<UpdateInsuranceAfterVobDialogProps> = ({
  open,
  isSaving = false,
  onYes,
  onNo,
}) => {
  return (
    <Dialog
      open={open}
      onClose={isSaving ? undefined : onNo}
      maxWidth="xs"
      fullWidth
      test-id="update-insurance-after-vob-dialog"
      sx={{ '& .MuiDialog-paper': { maxWidth: 'calc(444px * 1.3)' } }}
    >
      <DialogTitle sx={{ textAlign: 'center' }}>Save Changes?</DialogTitle>
      <DialogContent>
        <Typography align="center" sx={{ mb: 1 }}>
          New VOB created with the current values in the form.
        </Typography>
        <Typography align="center">
          Do you want to update the patient's demographics, and current insurance
          with the values used for this Availity VOB?
        </Typography>
      </DialogContent>
      <DialogActions sx={{ justifyContent: 'center', gap: 1, pb: 2 }}>
        <Button
          onClick={onNo}
          disabled={isSaving}
          test-id="update-insurance-after-vob-no"
        >
          No
        </Button>
        <Button
          onClick={onYes}
          disabled={isSaving}
          test-id="update-insurance-after-vob-yes"
        >
          {isSaving ? 'Saving...' : 'Yes'}
        </Button>
      </DialogActions>
    </Dialog>
  );
};
